import API                          from '../../../common/http/api.fetch';
import {success, responseMessage}   from '../../../common/utils/util.notifier';
import I18N                         from '../../../common/utils/util.i18n';
import { TYPES }                    from './audit-action-type.constants';
import { TYPES as ACC_TYPES }                    from '../accreditation-action-type.constants';
import { IDS }                      from './audit-action-id.constants';
import moment from 'moment';


export const fetchAudits = (scheme_code, slo_uuid, fiscal_year, fiscalYearStart, task_type = undefined, exportFormat = undefined) => {
    return dispatch => {
        const numYearsDisplayed = 2;
        return API.fetch({
            url: '/rco/list-requirement-audits',
            method: 'GET',
            params: {
                scheme_code,
                slo_uuid,
                fiscal_year,
            }
        }).then(response => {
                if(exportFormat)
                    return response;

                const hasChildrenWithAudits = (section) => {
                    const sectionNumber = section.section_name.split(' ')[0];
                    const children = response.data.filter(child => child.section_name.startsWith(sectionNumber + '.'));
                    return children.some(child => child.audit_tasks && JSON.parse(child.audit_tasks).filter(i => i!== null).length > 0);
                }
                response.data.forEach(section => {
                    section.hasChildrenWithAudits = section.requirement_level === 2 && hasChildrenWithAudits(section);
                });

                const sectionRows = response.data.map(section => {
                    const cells = section.requirement_level === 1 ? [] : Array(numYearsDisplayed * 12);
                    const auditors = JSON.parse(section.audit_tasks);
                    const firstReviewTask = auditors.length ? auditors[0] : null;
                    if(firstReviewTask) {
                        const dueDate = moment(firstReviewTask.due_date);
                        const yearOffset = (dueDate.year() - fiscal_year) * 12;
                        const cellIndex = dueDate.month() - fiscalYearStart + yearOffset;
                        cells[cellIndex] = {
                            auditors,
                            sectionId:      section.ase_id,
                            auditId:        section.id,
                            sectionName:    section.section_name,
                            sectionLevel:   section.requirement_level,
                            statusCode:     section.status,
                            statusName:     I18N.translate(`ACCREDITATION.TASKS.STATUS.${section.status.toUpperCase()}`),
                            date:           firstReviewTask.due_date,
                        }
                    }
                    const level = section.requirement_level;
                    let hasParentWithChildrenAudits = false;
                    if(level === 3) {
                        const parentSectionNumber = section.section_name.split(' ')[0].split('.').slice(0, -1).join('.');
                        const parent = response.data.find(item => item.section_name.startsWith(parentSectionNumber + ' '));
                        hasParentWithChildrenAudits = !!parent?.hasChildrenWithAudits;
                    }
                    return {
                        id: section.ase_id,
                        level,
                        name: level === 1 ? '' : section.section_name,
                        title: level === 1 ? section.section_name : '',
                        colspan: level === 1 ? numYearsDisplayed * 12 : 1,
                        status: section.status,
                        disabled: section.disabled,
                        cells,
                        hideRow: Boolean((level === 2 && section.hasChildrenWithAudits)
                            || (level === 3 && !hasParentWithChildrenAudits)) // any of the children of this section has audits
                    }
                });

                const date = moment().year(fiscal_year).month(fiscalYearStart).subtract(1, 'months');
                const monthColumns = [...Array(numYearsDisplayed * 12).keys()].map(() => {
                    return date.add(1, 'months').format('MMM YYYY');
                });

                const currentYear = moment().year();
                const currentMonth = moment().month();
                let currentFiscalYear = currentYear;
                if (currentMonth < fiscalYearStart) {
                    currentFiscalYear -= 1;
                }

                dispatch({
                    type: TYPES.FETCH_SCHEDULE,
                    id: IDS.accAudit,
                    monthColumns,
                    sectionRows,
                    currentFiscalYear,
                });
            },
            error => responseMessage(error))
    }
}

export const fetchSiteLocationDetails = (siteLocationUuid) => {
    return dispatch => {
        return API.fetch({
            url: `/location/sitelocation/${siteLocationUuid}`,
            method: 'GET',
            params: {}
        }).then(response => {
            const siteLocation = response.data[0][0];
            const fiscalYearStart = parseInt(siteLocation.fiscal_year_start) - 1;
            let maxYear = moment().year();
            if(fiscalYearStart <= moment().month()) {
                maxYear++;
            }
            const maxDueDate = moment(`${maxYear}-01-01`).add(fiscalYearStart, 'months').subtract(1,'days').toDate();
            const minDueDate = new Date();
            dispatch({
                type: TYPES.FETCH_SITE_LOCATION_DETAILS,
                siteLocation: {
                    locationName: siteLocation.name,
                    uuid: siteLocation.subject_uuid,
                    fiscalYearStart,
                    maxDueDate,
                    minDueDate,
                },
            })

            let fiscalYear = moment().year();
            if(fiscalYearStart > moment().month()) {
                fiscalYear--;
            }
            dispatch({
                type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    year: fiscalYear,
                }
            })
        })
    }
}

export const fetchSiteLocationContacts = (slo_uuid) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/list-auditor-candidates`,
            method: 'GET',
            params: {
                slo_uuid,
            }
        }).then(({data}) => {
            dispatch({
                type: TYPES.FETCH_SITE_CONTACT_CANDIDATES,
                autocompleteAuditors: data.reduce((result, user) => {
                    if(!result.find(item => item.sub_uuid === user.sub_uuid)) {
                        result.push(user);
                    }
                    return result;
                },[]),
            })
        })
    }
}

export const addAuditor = (item) => {
    return dispatch => {
        return dispatch({
            type: TYPES.ADD_AUDIT_ASSIGNEE,
            id: IDS.accAudit,
            path: 'details.auditors',
            item
        });
    };
};

export const setRequirementApplicability = (ase_id, scheme_code, slo_uuid, fiscal_year, is_disabled) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/set-requirement-applicability`,
            method: 'PUT',
            params: {
                ase_id,
                scheme_code,
                slo_uuid,
                fiscal_year,
                is_disabled
            }
        }).then(({data}) => {
            dispatch({
                type: TYPES.SET_REQUIREMENT_APPLICABILITY,
                requirementId: ase_id,
                disabled: is_disabled,
            })
        })
    }
}